/* Core-01 product page behaviour. No jQuery, no polling. Variant truth comes from Dawn's
   <variant-selects>, which updates the form's hidden id input and dispatches `change` on it. */
(function () {
  'use strict';
  if (window.__corePdp) return; window.__corePdp = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const css = (el, v) => getComputedStyle(el).getPropertyValue(v).trim();

  const main = document.querySelector('[data-core-main]');
  const variantsScript = main && main.querySelector('variant-selects [type="application/json"], .variant-selects [type="application/json"]');
  const variants = variantsScript ? JSON.parse(variantsScript.textContent) : (function () {
    const s = document.querySelector('[data-core-variants]'); return s ? JSON.parse(s.textContent) : [];
  })();
  const idInput = main && main.querySelector('form [name="id"]');
  const currency = (main && main.dataset.currency) || 'USD';
  const money = (cents) => {
    const n = cents / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, minimumFractionDigits: Number.isInteger(n) ? 0 : 2, maximumFractionDigits: 2 }).format(n); }
    catch (e) { return '$' + (Number.isInteger(n) ? n : n.toFixed(2)); }
  };
  const currentVariant = () => variants.find(v => String(v.id) === String(idInput && idInput.value)) || variants[0];

  /* Loadout option: Standard (first value) vs Extended (any other) */
  const loadoutSet = main && main.querySelector('[data-core-loadout]');
  const loadoutInputs = loadoutSet ? [...loadoutSet.querySelectorAll('input[type="radio"]')] : [];
  const loadoutValue = () => { const c = loadoutInputs.find(i => i.checked); return c ? c.value : null; };
  const isExtended = () => loadoutInputs.length > 1 && loadoutValue() !== loadoutInputs[0].value;
  const loadoutIndex = (() => {
    if (!main || !loadoutSet) return -1;
    if (main.dataset.optionNames) { const inp = loadoutSet.querySelector('input'); const names = JSON.parse(main.dataset.optionNames); return inp ? names.indexOf(inp.name) : -1; }
    return [...main.querySelectorAll('variant-selects fieldset, .variant-selects fieldset')].indexOf(loadoutSet);
  })();
  /* Self-managed panels (no Dawn product-info): resolve the variant from the checked radios ourselves */
  if (main && main.hasAttribute('data-core-selfmanaged') && idInput) {
    const resolve = () => {
      const names = (variants[0] && variants[0].options ? variants[0].options.length : 0);
      const fields = [...main.querySelectorAll('.variant-selects fieldset')];
      const byName = {}; fields.forEach(f => { const inp = f.querySelector('input[type="radio"]'); if (inp) byName[inp.name] = f; });
      const optionNames = main.dataset.optionNames ? JSON.parse(main.dataset.optionNames) : Object.keys(byName);
      const chosen = optionNames.map(n => { const f = byName[n]; const c = f && f.querySelector('input:checked'); return c ? c.value : null; });
      const v = variants.find(v => v.options && v.options.every((o, i) => o === chosen[i]));
      if (v && String(v.id) !== String(idInput.value)) { idInput.value = v.id; idInput.disabled = !v.available; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      else if (v) { idInput.disabled = !v.available; }
      const btn = main.querySelector('product-form button[type="submit"]'); if (btn && v) { btn.disabled = !v.available; btn.firstElementChild.textContent = ctaWord(v); } paintPre(v);
    };
    main.addEventListener('change', e => { if (e.target.matches('.variant-selects input[type="radio"]')) resolve(); });
  }
  /* Pre-order: stock 0 with "continue selling" on. The ship date and label ride on the buy button's data attributes. */
  const poBtn = () => document.querySelector('[data-po-date]');
  const isPre = v => { const b = poBtn(); return !!(v && v.available && b && (',' + (b.dataset.poIds || '')).indexOf(',' + v.id + ',') >= 0); };
  const stockWord = v => isPre(v) ? 'PRE-ORDER · SHIPS ' + ((poBtn() || { dataset: {} }).dataset.poDate || '').toUpperCase() : (v.available ? 'IN STOCK' : 'SOLD OUT');
  const ctaWord = v => isPre(v) ? ((poBtn() || { dataset: {} }).dataset.poLabel || 'Pre-order') : (v.available ? 'Add to cart' : 'Sold out');
  const paintPre = v => {
    if (!v) return;
    document.querySelectorAll('[data-po-prop]').forEach(i => { i.disabled = !isPre(v); });
    document.querySelectorAll('[data-po-line]').forEach(el => { el.textContent = isPre(v) ? el.dataset.po : (v.available ? el.dataset.instock : (el.dataset.soldout || 'Sold out.')); el.classList.toggle('po', isPre(v)); el.classList.toggle('out', !v.available); });
    document.querySelectorAll('product-form button[type="submit"] > span:first-child, [data-core-submit-main] > span:first-child').forEach(sp => { sp.textContent = ctaWord(v); });
    document.querySelectorAll('product-form button[type="submit"]').forEach(b => b.classList.toggle('po', isPre(v)));
  };
  window.__rrPaintPre = () => { try { paintPre(currentVariant()); } catch (e) {} };
  const colorName = (v) => { if (!v) return ''; if (loadoutIndex < 0 || !v.options) return v.title; return v.options.filter((o, i) => i !== loadoutIndex).join(' / '); };
  const variantFor = (loadout, base) => variants.find(v => v.options && v.options.every((o, i) => i === loadoutIndex ? o === loadout : o === base.options[i]));
  function chooseLoadout(value) {
    const input = loadoutInputs.find(i => i.value === value);
    if (!input || input.checked) return false;
    input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); return true;
  }

  /* ---------- Gallery ---------- */
  function setActiveMedia(mediaId) {
    if (!main || !mediaId) return;
    main.querySelectorAll('.frame .media').forEach(m => m.classList.toggle('is-active', String(m.dataset.mediaId) === String(mediaId)));
    main.querySelectorAll('.thumb').forEach(t => t.classList.toggle('is-active', String(t.dataset.thumbFor) === String(mediaId)));
  }
  if (main) main.querySelectorAll('.thumb').forEach(t => t.addEventListener('click', () => setActiveMedia(t.dataset.thumbFor)));
  /* Phone grammar shared with the pack galleries: counter, arrows, swipe and tap advance; the active thumb scrolls into view */
  (function () {
    const g = main && main.querySelector('[data-core-gallery]'); if (!g) return;
    const thumbs = [...g.querySelectorAll('.thumb')]; if (thumbs.length < 2) return;
    const count = g.querySelector('[data-core-count]'), pad = n => String(n).padStart(2, '0');
    const idx = () => Math.max(0, thumbs.findIndex(t => t.classList.contains('is-active')));
    const paint = () => {
      const i = idx(); if (count) count.textContent = `${pad(i + 1)} / ${pad(thumbs.length)}`;
      const t = thumbs[i], c = t.parentElement; if (c && c.scrollWidth > c.clientWidth + 1) c.scrollTo({ left: Math.max(0, t.offsetLeft - (c.clientWidth - t.offsetWidth) / 2), behavior: document.hidden ? 'auto' : 'smooth' });
    };
    const go = n => { const i = ((n % thumbs.length) + thumbs.length) % thumbs.length; setActiveMedia(thumbs[i].dataset.thumbFor); paint(); };
    g.querySelectorAll('[data-core-prev]').forEach(b => b.addEventListener('click', () => go(idx() - 1)));
    g.querySelectorAll('[data-core-next]').forEach(b => b.addEventListener('click', () => go(idx() + 1)));
    thumbs.forEach(t => t.addEventListener('click', paint));
    const frame = g.querySelector('[data-core-frame]'); let sx = 0, sy = 0, moved = false;
    if (frame) {
      frame.addEventListener('pointerdown', e => { sx = e.clientX; sy = e.clientY; moved = false; });
      frame.addEventListener('pointerup', e => {
        if (!matchMedia('(max-width: 860px)').matches) return;
        const dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx() + (dx < 0 ? 1 : -1));
        else if (Math.abs(dx) < 8 && Math.abs(dy) < 8 && !e.target.closest('button, a')) go(idx() + 1);
      });
    }
    paint();
  })();

  /* ---------- Hero placeholder (only when the product has no media) ---------- */
  const hero = document.querySelector('[data-core-hero]');
  function swatchHex() {
    const checked = main && main.querySelector('.swatch input:checked');
    const label = checked && checked.closest('.swatch');
    return (label && css(label, '--sw')) || '#1C1C1C';
  }
  function drawHero() {
    if (!hero) return;
    const dpr = devicePixelRatio || 1, r = hero.getBoundingClientRect();
    if (!r.width) return;
    hero.width = r.width * dpr; hero.height = r.height * dpr;
    const c = hero.getContext('2d'); c.scale(dpr, dpr);
    const W = r.width, H = r.height, fg = css(main, '--rr-fg'), mute = css(main, '--rr-mute');
    c.clearRect(0, 0, W, H);
    const pw = W * .5, ph = pw * 1.55, px = (W - pw) / 2, py = (H - ph) / 2;
    c.fillStyle = swatchHex(); c.strokeStyle = mute; c.lineWidth = 1;
    c.fillRect(px - 26, py - 22, pw + 52, ph + 44); c.strokeRect(px - 26, py - 22, pw + 52, ph + 44);
    c.fillStyle = '#0E0E0E'; c.fillRect(px, py, pw, ph); c.strokeStyle = fg; c.globalAlpha = .55; c.strokeRect(px, py, pw, ph); c.globalAlpha = 1;
    const cols = 6, rows = 10, sw = pw / cols, sh = ph / rows;
    c.strokeStyle = fg; c.globalAlpha = .35;
    for (let i = 0; i < cols; i++) for (let j = 0; j < rows; j++) c.strokeRect(px + i * sw + sw * .22, py + j * sh + sh * .28, sw * .56, sh * .44);
    c.globalAlpha = 1;
    ['--rr-trauma', '--rr-rescue', '--rr-cover', '--rr-forge', '--rr-protect'].forEach((m, i) => {
      const mh = ph * .13, gap = ph * .03, y = py + ph * .1 + i * (mh + gap);
      c.fillStyle = css(main, m); c.globalAlpha = .92; c.fillRect(px + pw * .08, y, pw * .84, mh); c.globalAlpha = 1;
    });
  }

  /* ---------- Variant change → labels, prices, gallery, sticky readout ---------- */
  function onVariant() {
    const v = currentVariant(); if (!v) return;
    const cn = colorName(v);
    document.querySelectorAll('[data-core-color-name]').forEach(el => {
      /* multi-option products: each legend shows the chosen value of its own option */
      const legends = [...document.querySelectorAll('[data-selected-swatch-value]')];
      const names = [...new Set(legends.map(l => l.dataset.selectedSwatchValue))];
      const idx = names.indexOf(el.dataset.selectedSwatchValue);
      const own = idx >= 0 && names.length > 1 ? v['option' + (idx + 1)] : null;
      const label = own || cn; el.textContent = (label === 'Default Title') ? '' : label;
    });
    document.querySelectorAll('[data-core-color-label]').forEach(el => {
      const parts = el.textContent.split('·'); el.textContent = parts.length > 1 ? cn + ' ·' + parts.slice(1).join('·') : cn;
    });
    document.querySelectorAll('[data-core-cta-price]').forEach(el => el.textContent = money(v.price));
    if (v.featured_media) setActiveMedia(v.featured_media.id);
    /* the swipe gallery (pack hero) listens for this and slides to the chosen colour's photo */
    if (v.featured_media) document.dispatchEvent(new CustomEvent('rr:variant-media', { detail: v.featured_media.id }));
    const idx = variants.indexOf(v) + 1;
    document.querySelectorAll('[data-core-status]').forEach(el => {
      const single = variants.length < 2 || /^default title$/i.test(v.title);
      el.textContent = single
        ? stockWord(v)
        : 'SELECTED · ' + v.title.toUpperCase() + ' · ' + String(idx).padStart(2, '0') + '/' + String(variants.length).padStart(2, '0') + ' · ' + stockWord(v);
    });
    document.querySelectorAll('[data-core-submit-main]').forEach(b => b.toggleAttribute('disabled', !v.available));
    paintPre(v);
    applyLoadout();
    drawHero();
  }
  function applyLoadout() {
    const ext = isExtended(), lv = loadoutValue();
    // hero fallback media keyed by loadout
    if (main) main.querySelectorAll('[data-loadout-media]').forEach(m => m.classList.toggle('is-active', (m.dataset.loadoutMedia === 'extended') === ext));
    const cap = document.querySelector('[data-core-loadout-caption]');
    if (cap && loadoutSet) { const opt = loadoutSet.querySelector('.plan-opt input:checked'); const pd = opt && opt.closest('.plan-opt').querySelector('.pd'); if (pd) cap.textContent = pd.textContent; }
    // included line
    const inc = document.querySelector('[data-core-included]');
    if (inc && loadoutInputs.length) inc.textContent = ext ? (inc.dataset.extended || inc.dataset.standard) : inc.dataset.standard;
    // stickers + upgrade line, aware of Extended availability for the selected color
    const cur = currentVariant();
    const extValue = loadoutInputs.length > 1 ? loadoutInputs[loadoutInputs.length - 1].value : null;
    const extVariant = (extValue && cur) ? variantFor(extValue, cur) : null;
    const extAvailable = !!(extVariant && extVariant.available);
    document.querySelectorAll('.st[data-upgrade]').forEach(st => {
      st.classList.toggle('is-locked', loadoutInputs.length ? !ext : false);
      st.classList.toggle('is-unavailable', loadoutInputs.length ? (!ext && !extAvailable) : false);
    });
    const grp = document.querySelector('[data-core-upgrade-group]');
    if (grp) {
      const act = grp.querySelector('[data-core-upgrade-act]'), d = grp.querySelector('[data-core-upgrade-delta]'), tile = grp.querySelector('[data-core-upgrade-toggle]');
      const delta = (extVariant && cur) ? extVariant.price - cur.price : 0;
      grp.classList.toggle('is-in', loadoutInputs.length ? ext : false);
      const buyBox = grp.closest('.stickers') && grp.closest('.stickers').querySelector('.buy-inline'); if (buyBox) buyBox.classList.toggle('is-ext', loadoutInputs.length ? ext : false);
      try { syncGroupSnake(); setTimeout(syncGroupSnake, 250); setTimeout(syncGroupSnake, 600); } catch (e) {} /* the group is hidden until switched on in solves mode; size its outline now and again after the box reflows */
      if (!loadoutInputs.length) { if (tile) tile.hidden = true; }
      else if (ext) { act.textContent = 'In your loadout'; d.textContent = ''; }
      else { act.textContent = extAvailable ? '+ Add to loadout' : 'Extended sold out'; d.textContent = extAvailable && delta > 0 ? ' · +' + money(delta) : ''; }
      if (tile) tile.disabled = loadoutInputs.length ? (!ext && !extAvailable) : true;
    }
    const up = document.querySelector('[data-core-upgrade-line]');
    if (up) {
      const show = loadoutInputs.length > 1 && !ext && extVariant;
      up.hidden = !show;
      if (show) {
        const delta = extVariant.price - cur.price;
        up.querySelector('[data-core-upgrade-delta]').textContent = extAvailable ? (delta > 0 ? '+' + money(delta) : money(extVariant.price)) : 'SOLD OUT';
        const opt = loadoutSet.querySelector('.plan-opt[data-loadout-value="' + extValue + '"] .pd');
        up.querySelector('[data-core-upgrade-sub]').textContent = opt ? opt.textContent : '';
        up.disabled = !extAvailable;
      }
    }
    // plans in compare
    document.querySelectorAll('[data-plan-for]').forEach(p => { const on = p.dataset.planFor === lv; p.classList.toggle('hi', on); const b = p.querySelector('.cta'); if (b) b.classList.toggle('ghost', !on); });
    document.querySelectorAll('[data-core-loadout-switch]').forEach(sw => {
      sw.setAttribute('aria-pressed', String(ext)); const d = sw.querySelector('[data-core-switch-delta]');
      const delta = (extVariant && cur) ? extVariant.price - cur.price : 0;
      if (d) d.textContent = ext ? 'Included' : (extAvailable ? (delta > 0 ? '+' + money(delta) : '') : 'Sold out');
      sw.disabled = !ext && !extAvailable;
    });
    // homepage readout: "Core-01 · $199" / "Core-01 with Forge and Protect · $299"
    document.querySelectorAll('[data-core-readout]').forEach(el => { const v = currentVariant(); if (!v) return; const base = (el.dataset.base || el.textContent.split(' Extended')[0].split(' with ')[0].split(' · ')[0]).trim(); el.dataset.base = base; el.innerHTML = base + (ext ? ' <strong>Extended</strong>' : '') + ' · ' + money(v.price); });
    // status readout
    document.querySelectorAll('[data-core-status]').forEach(el => { const v = currentVariant(); if (!v) return; const parts = ['SELECTED']; if (lv) parts.push(lv.toUpperCase()); const cn = colorName(v); if (cn) parts.push(cn.toUpperCase()); parts.push(stockWord(v)); el.textContent = parts.length > 2 ? parts.join(' · ') : parts[parts.length - 1]; }); paintPre(currentVariant());
  }
  /* Loadout switch beside Add to cart (homepage purchase block): toggles Standard ↔ Extended */
  document.querySelectorAll('[data-core-loadout-switch]').forEach(sw => sw.addEventListener('click', () => {
    if (loadoutInputs.length < 2) return;
    chooseLoadout(isExtended() ? loadoutInputs[0].value : loadoutInputs[loadoutInputs.length - 1].value);
  }));
  const grpToggle = document.querySelector('[data-core-upgrade-toggle]');
  if (grpToggle) grpToggle.addEventListener('click', () => {
    if (loadoutInputs.length < 2) return;
    const ext = loadoutInputs[loadoutInputs.length - 1].value, std = loadoutInputs[0].value;
    const nowExt = isExtended();
    if (chooseLoadout(nowExt ? std : ext) && status) status.textContent = nowExt ? 'FORGE + PROTECT · REMOVED FROM LOADOUT' : 'FORGE + PROTECT · ADDED TO LOADOUT';
  });
  const upLine = document.querySelector('[data-core-upgrade-line]');
  if (upLine) upLine.addEventListener('click', () => { if (loadoutInputs.length > 1) chooseLoadout(loadoutInputs[loadoutInputs.length - 1].value); });
  document.querySelectorAll('[data-core-choose-loadout]').forEach(b => b.addEventListener('click', () => {
    const changed = chooseLoadout(b.dataset.coreChooseLoadout);
    const form = main && main.querySelector('product-form form');
    if (!form) return;
    setTimeout(() => { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }, changed ? 350 : 0);
  }));
  /* Compare cards: clicking the card selects that loadout (the button inside still adds to cart) */
  document.querySelectorAll('[data-plan-for]').forEach(card => card.addEventListener('click', e => {
    if (e.target.closest('button, a')) return;
    chooseLoadout(card.dataset.planFor);
  }));
  if (idInput) idInput.addEventListener('change', onVariant);
  if (main) main.querySelectorAll('.swatch input').forEach(i => i.addEventListener('change', () => setTimeout(onVariant, 0)));
  loadoutInputs.forEach(i => i.addEventListener('change', () => setTimeout(onVariant, 0)));

  /* ---------- Remote submit buttons (sticky bar, compare, final) ---------- */
  document.querySelectorAll('[data-core-submit-main]').forEach(b => b.addEventListener('click', () => {
    const form = main && main.querySelector('product-form form');
    if (!form) return;
    /* The main button is usually off screen when a remote one is tapped, so the remote button carries the feedback:
       dashes while the add runs, then the tick. It follows the main button's own loading class. */
    const mainBtn = form.querySelector('button[type="submit"]');
    if (mainBtn && window.MutationObserver && !b.classList.contains('loading')) {
      if (!b.querySelector('.loading__spinner')) { const sp = document.createElement('div'); sp.className = 'loading__spinner'; sp.setAttribute('aria-hidden', 'true'); b.appendChild(sp); }
      let began = false;
      const mo = new MutationObserver(() => {
        const on = mainBtn.classList.contains('loading');
        if (on && !began) { began = true; b.classList.add('loading'); return; }
        if (!on && began) {
          mo.disconnect(); b.classList.remove('loading');
          setTimeout(() => {
            if (mainBtn.getAttribute('aria-disabled') === 'true') return; /* the add failed: the form shows why */
            if (!b.querySelector('.cta-ok')) { const ok = document.createElement('i'); ok.className = 'cta-ok'; ok.setAttribute('aria-hidden', 'true'); b.appendChild(ok); }
            b.classList.add('is-done'); setTimeout(() => b.classList.remove('is-done'), 1100);
          }, 0);
        }
      });
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['class'] });
      setTimeout(() => { if (!began) mo.disconnect(); }, 1500);
    }
    if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }));

  /* ---------- Sticky bar ---------- */
  const sticky = document.querySelector('[data-core-sticky]');
  const decide = main && main.querySelector('.decide');
  if (sticky && decide) {
    /* Show once the buy column has scrolled past the top — and never while any other add-to-cart control
       (compare cards, final plate) is on screen: one buy control at a time. Plain rect math on scroll. */
    const others = [...document.querySelectorAll('[data-core-submit-main], [data-core-choose-loadout]')].filter(b => !sticky.contains(b));
    let raf = 0, last = null;
    const paint = () => {
      raf = 0; if (!decide.isConnected) return;
      const vh = innerHeight, passed = decide.getBoundingClientRect().bottom < 0;
      const busy = others.some(b => { const r = b.getBoundingClientRect(); return r.bottom > 0 && r.top < vh + 72 && r.width > 0; });
      const show = passed && !busy;
      if (show === last) return; last = show;
      sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show)); sticky.toggleAttribute('inert', !show);
      document.body.classList.toggle('rr-sticky-open', show); /* lifts the Shopify Inbox bubble clear of the bar */
    };
    const tick = () => { if (!raf) raf = setTimeout(paint, 16); }; /* timer, not rAF: rAF pauses in background tabs and the bar must still settle */
    addEventListener('scroll', tick, { passive: true }); addEventListener('resize', tick); paint();
  }

  /* ---------- Pack page: plate height follows the closed decision column ---------- */
  const packGrid = document.querySelector('.pack-buy .wrap.grid, .core-buy .wrap.grid');
  if (packGrid) {
    const decide = packGrid.querySelector('.decide'), ident = packGrid.querySelector('.ident:not(.decide *)') || decide;
    const measure = () => {
      if (!ident || !decide) return;
      let h = decide.getBoundingClientRect().bottom - ident.getBoundingClientRect().top;
      /* measure the column as if every fold were closed */
      packGrid.querySelectorAll('.folds details[open] .body').forEach(b => { h -= b.getBoundingClientRect().height; });
      if (h > 0) packGrid.style.setProperty('--rr-col-h', Math.round(h) + 'px');
    };
    measure();
    addEventListener('resize', measure, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    /* the column keeps changing after first paint (price and plan rows filled in by script, late styles): re-measure whenever it does */
    if (window.ResizeObserver && decide) { const ro = new ResizeObserver(measure); ro.observe(decide); if (ident !== decide) ro.observe(ident); }
    addEventListener('load', measure);
  }

  /* ---------- X-ray scan (point cloud) + stickers ---------- */
  const xray = document.querySelector('[data-core-xray]');
  const scan = document.querySelector('[data-core-scan]');
  const status = document.querySelector('[data-core-scan-status]');
  const hint = status ? status.textContent : '';
  let active = null, pts = null, visible = false, last = 0;
  function buildPts(W, H) {
    const pw = Math.min(W * .62, H * .52), ph = pw * 1.6, px = (W - pw) / 2, py = (H - ph) / 2, out = [];
    const rnd = () => (Math.random() - .5);
    const edge = (x1, y1, x2, y2, n, slot) => { for (let i = 0; i < n; i++) { const t = Math.random(); out.push({ x: x1 + (x2 - x1) * t + rnd() * 2.2, y: y1 + (y2 - y1) * t + rnd() * 2.2, slot }); } };
    const ch = pw * .08, P = [[px + ch, py], [px + pw - ch, py], [px + pw, py + ch], [px + pw, py + ph - ch], [px + pw - ch, py + ph], [px + ch, py + ph], [px, py + ph - ch], [px, py + ch]];
    for (let i = 0; i < P.length; i++) { const a = P[i], b = P[(i + 1) % P.length]; edge(a[0], a[1], b[0], b[1], Math.hypot(b[0] - a[0], b[1] - a[1]) * 1.1, 0); }
    const rows = 9, cols = 5, sh = ph / (rows + 1), sw = pw / (cols + .8);
    const slotCount = Math.max(1, document.querySelectorAll('.st:not(.core)').length);
    for (let r = 0; r < rows; r++) for (let k = 0; k < cols; k++) {
      const x = px + sw * .5 + k * sw, y = py + sh * .55 + r * sh, w = sw * .72, h = sh * .5;
      const slot = Math.min(slotCount, Math.floor(r / rows * slotCount) + 1);
      edge(x, y, x + w, y, w * .7, slot); edge(x + w, y, x + w, y + h, h * .7, slot); edge(x + w, y + h, x, y + h, w * .7, slot); edge(x, y + h, x, y, h * .7, slot);
    }
    for (let i = 0; i < 220; i++) out.push({ x: px + Math.random() * pw, y: py + Math.random() * ph, slot: 0, noise: true });
    return out;
  }
  function slotColor(slot) {
    const st = document.querySelector('.st[data-slot="' + slot + '"]');
    return st ? css(st, '--st') || '#F2F2F0' : '#F2F2F0';
  }
  const overlay = scan && scan.hasAttribute('data-overlay') && xray.querySelector('img');
  function drawOverlay(t) {
    const dpr = devicePixelRatio || 1, r = scan.getBoundingClientRect();
    if (!r.width) return;
    if (scan.width !== Math.round(r.width * dpr)) { scan.width = Math.round(r.width * dpr); scan.height = Math.round(r.height * dpr); }
    const c = scan.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, r.width, r.height);
    // panel bounds inside the square scan image (object-fit: contain)
    const side = Math.min(r.width, r.height), ox = (r.width - side) / 2, oy = (r.height - side) / 2;
    const px = ox + side * .25, pw = side * .49, py = oy + side * .07, ph = side * .86;
    const slots = Math.max(1, document.querySelectorAll('.st:not(.core)').length);
    if (!reduced) { const sweep = py + ((t / 2400) % 1) * ph; const g = c.createLinearGradient(0, sweep - 30, 0, sweep + 2); g.addColorStop(0, 'rgba(242,242,240,0)'); g.addColorStop(1, 'rgba(242,242,240,.35)'); c.fillStyle = g; c.globalAlpha = 1; c.fillRect(px, sweep - 30, pw, 32); }
    c.globalAlpha = 1;
  }
  function drawScan(t) {
    if (!scan) return;
    if (overlay) return drawOverlay(t);
    const dpr = devicePixelRatio || 1, r = scan.getBoundingClientRect();
    if (!r.width) return;
    if (!pts || scan.width !== Math.round(r.width * dpr)) { scan.width = Math.round(r.width * dpr); scan.height = Math.round(r.height * dpr); pts = buildPts(r.width, r.height); }
    const c = scan.getContext('2d'); c.setTransform(dpr, 0, 0, dpr, 0, 0); c.clearRect(0, 0, r.width, r.height);
    const fg = css(xray, '--rr-fg');
    const sweep = reduced ? -1 : ((t / 2400) % 1.4) * r.height;
    for (const p of pts) {
      const hi = active && p.slot === +active, dim = active && !hi;
      c.fillStyle = hi ? slotColor(p.slot) : fg;
      let a = p.noise ? .18 : .7; if (dim) a *= .18; if (hi) a = .95;
      if (sweep > 0) { const d = Math.abs(p.y - sweep); if (d < 40) a = Math.min(1, a + (1 - d / 40) * .5); }
      c.globalAlpha = a; c.fillRect(p.x, p.y, hi ? 1.8 : 1.2, hi ? 1.8 : 1.2);
    }
    c.globalAlpha = 1;
  }
  function loop(t) { if (visible && t - last > 40) { last = t; drawScan(t); } requestAnimationFrame(loop); }
  if (xray && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) drawScan(performance.now()); }).observe(xray);
    if (!reduced && scan) requestAnimationFrame(loop);
  }
  /* One selection at all times. Core-01 is preselected; the dash lives on whatever was tapped last.
     Module stickers also reveal their contents while selected. */
  document.querySelectorAll('.st').forEach(b => b.addEventListener('click', () => {
    const s = b.dataset.slot;
    document.querySelectorAll('.st').forEach(x => {
      const me = x === b;
      x.classList.toggle('is-active', me);
      x.classList.toggle('is-open', me && s !== 'core');
      if (x.hasAttribute('aria-expanded')) x.setAttribute('aria-expanded', String(me && s !== 'core'));
      if (x.classList.contains('core')) x.setAttribute('aria-pressed', String(me));
    });
    active = s !== 'core' ? s : null;
    document.querySelectorAll('.upgrade-group').forEach(g => g.classList.toggle('is-ext', b.dataset.upgrade === 'true'));
    if (window.__solvesSync && !b.__fromSolves) window.__solvesSync(s !== 'core' ? (b.dataset.upgrade === 'true' ? 'ext' : s) : null);
    let line = b.dataset.status || hint;
    if (b.classList.contains('is-locked')) line += b.classList.contains('is-unavailable') ? ' · SOLD OUT IN THIS COLOR' : ' · NOT IN YOUR LOADOUT';
    if (status) status.textContent = line;
  }));

  /* ---------- Sticker outline: 45° chamfer + rounded corners, drawn in real pixels so the
     clip shape and the single travelling dash share one accurate path ---------- */
  function outlinePath(W, H) {
    const r = Math.round(W * .035 * 100) / 100, c = Math.round(W * .09 * 100) / 100;
    return `M${r} 0H${W - c}L${W} ${c}V${H - r}Q${W} ${H} ${W - r} ${H}H${r}Q0 ${H} 0 ${H - r}V${r}Q0 0 ${r} 0Z`;
  }
  function ctaPath(W, H) {
    // 5px radius on three corners; 45° chamfer top-right whose two ends are also softened (Michael's Figma reference)
    const r = 5, c = Math.max(12, Math.round(H * .32)), k = 4, d = k / Math.SQRT2;
    return `M${r} 0H${W - c - k}Q${W - c} 0 ${W - c + d} ${d}L${W - d} ${c - d}Q${W} ${c} ${W} ${c + k}V${H - r}Q${W} ${H} ${W - r} ${H}H${r}Q0 ${H} 0 ${H - r}V${r}Q0 0 ${r} 0Z`;
  }
  /* Rounded frame with one 45° chamfer at the top-right: data-chamfer="radius,chamfer" (px) */
  function framePath(W, H, r, c) { return `M${r} 0H${W - c}L${W} ${c}V${H - r}Q${W} ${H} ${W - r} ${H}H${r}Q0 ${H} 0 ${H - r}V${r}Q0 0 ${r} 0Z`; }
  function framePathRight(W, H, r, c) { return `M0 0H${W - c}L${W} ${c}V${H - r}Q${W} ${H} ${W - r} ${H}H0Z`; }
  /* chamfer top-left, radius bottom-left, square on the right (bleeds off the right edge) */
  function framePathLeftBleed(W, H, r, c) { return `M${c} 0H${W}V${H}H${r}Q0 ${H} 0 ${H - r}V${c}Z`; }
  function syncFrames() {
    document.querySelectorAll('[data-chamfer]').forEach(f => {
      const sec = f.closest('[data-plate-x]');
      if (sec) { const pct = parseFloat(sec.dataset.plateX) || 31.5; const wrap = f.parentElement; const pr = wrap.getBoundingClientRect(); const pad = parseFloat(getComputedStyle(wrap).paddingLeft) || 0; const x = Math.max(0, document.documentElement.clientWidth * pct / 100 - (pr.left + pad)); if (matchMedia('(min-width: 861px)').matches) wrap.style.setProperty('--x', x + 'px'); else wrap.style.removeProperty('--x'); }
      let [r, c] = (f.dataset.chamfer || '24,48').split(',').map(Number); const W = f.offsetWidth, H = f.offsetHeight; if (!W || !H) return;
      if (c > 0 && c < 1) c = Math.round(H * c);
      const side = f.dataset.chamferSide;
      if (side === 'right') { const pr = f.parentElement.getBoundingClientRect(); const pad = parseFloat(getComputedStyle(f.parentElement).paddingLeft) || 0; f.style.setProperty('--edge', Math.max(0, pr.left + pad) + 'px'); }
      if (side === 'left-bleed') { const pr = f.parentElement.getBoundingClientRect(); const pad = parseFloat(getComputedStyle(f.parentElement).paddingRight) || 0; const e = Math.max(0, document.documentElement.clientWidth - (pr.right - pad)) + 'px'; f.style.setProperty('--edge', e); f.parentElement.style.setProperty('--edge', e); }
      const fn = side === 'right' ? framePathRight : side === 'left-bleed' ? framePathLeftBleed : framePath;
      f.style.clipPath = `path("${fn(f.offsetWidth, f.offsetHeight, r, c)}")`;
    });
  }
  /* Film sound toggle: videos start muted (autoplay rule); one tap unmutes */
  document.querySelectorAll('[data-rr-sound]').forEach(b => b.addEventListener('click', () => {
    const v = b.parentElement.querySelector('video'); if (!v) return;
    v.muted = !v.muted; if (!v.muted && v.paused) v.play().catch(() => {});
    b.setAttribute('aria-pressed', String(!v.muted)); b.setAttribute('aria-label', v.muted ? 'Unmute film' : 'Mute film');
    b.querySelector('span').textContent = v.muted ? 'Sound off' : 'Sound on';
  }));
  function syncCtas() {
    syncFrames();
    document.querySelectorAll('.rr .cta').forEach(b => {
      const W = b.offsetWidth, H = b.offsetHeight; if (!W || !H) return;
      b.style.clipPath = `path("${ctaPath(W, H)}")`; b.style.setProperty('--cta-inner', `path("${ctaPath(W - 2, H - 2)}")`); b.setAttribute('data-cta-shaped', '');
    });
  }
  function syncStickers() {
    syncCtas();
    document.querySelectorAll('.rr .st').forEach(st => {
      const W = st.offsetWidth, H = st.offsetHeight; if (!W || !H) return;
      const d = outlinePath(W, H);
      st.style.clipPath = `path("${d}")`;
      const svg = st.querySelector('.snake'), path = svg && svg.querySelector('path');
      if (!path) return;
      svg.setAttribute('viewBox', `0 0 ${W} ${H}`); svg.removeAttribute('preserveAspectRatio');
      path.setAttribute('d', outlinePath(W - 2, H - 2)); path.setAttribute('transform', 'translate(1 1)');
      const L = path.getTotalLength(), dash = L * .32;
      st.style.setProperty('--dash', `${dash} ${L - dash}`);
      st.style.setProperty('--snake-to', `${-L}`);
    });
  }
  /* Extended group outline for its snake */
  function syncGroupSnake() {
    document.querySelectorAll('.rr .upgrade-group, .rr .buy-inline').forEach(g => {
      const svg = g.querySelector(':scope > .gsnake, :scope > .bsnake'), r = svg && svg.querySelector('rect'); if (!r) return;
      const W = svg.clientWidth || g.offsetWidth, H = svg.clientHeight || g.offsetHeight; if (!W || !H) return; /* the svg may sit outside the group (inset -6px) */
      const rad = parseFloat(getComputedStyle(g).borderTopLeftRadius) || 0;
      svg.setAttribute('viewBox', `0 0 ${W} ${H}`); r.setAttribute('width', W - 1.5); r.setAttribute('height', H - 1.5); r.setAttribute('rx', Math.max(0, rad - .75)); r.setAttribute('ry', Math.max(0, rad - .75));
      const L = r.getTotalLength(), dash = L * .22;
      g.style.setProperty('--dash', `${dash} ${L - dash}`); g.style.setProperty('--snake-to', `${-L}`);
    });
  }
  syncStickers(); syncGroupSnake();
  /* re-shape after web fonts and images settle: a CTA measured before Helvetica loads keeps a stale chamfer path and its hairline breaks */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { syncStickers(); syncGroupSnake(); });
  addEventListener('load', () => { syncStickers(); syncGroupSnake(); });
  if ('ResizeObserver' in window) { const ro = new ResizeObserver(() => { syncStickers(); syncGroupSnake(); }); document.querySelectorAll('.rr .st, .rr .cta, .rr .upgrade-group, .rr .buy-inline').forEach(el => ro.observe(el)); }
  else addEventListener('resize', syncStickers);

  /* ---------- Reveal ---------- */
  const rv = document.querySelectorAll('.rr .rv');
  /* rvImmediate: above-the-fold reveals paint at once (LCP) */
  rv.forEach(el => { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('in'); });
  if ('IntersectionObserver' in window && !reduced) {
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    rv.forEach(el => io.observe(el));
  } else rv.forEach(el => el.classList.add('in'));

  /* ---------- Init ---------- */
  const init = () => { drawHero(); onVariant(); };
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init); else init();
  addEventListener('resize', () => { drawHero(); pts = null; if (visible) drawScan(performance.now()); });
})();

/* solves mode engine: one active callout at a time, a dwell timer fills its rule/segment white, then advances.
   Taps advance (callout, phones) or jump (column / segment). Stickers and callouts stay in sync both ways.
   Pauses off-screen; no auto-advance under reduced motion. */
(function () {
  const wrap = document.querySelector('[data-solves-verbs]') || document.querySelector('[data-solves]'); if (!wrap) return;
  if (!wrap.dataset.dwell) { const src = document.querySelector('[data-solves]'); wrap.dataset.dwell = src ? src.dataset.dwell : '4500'; }
  const items = [...wrap.querySelectorAll('.solve')], segs = [...wrap.querySelectorAll('.seg')];
  if (!items.length) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const dwell = reduced ? Infinity : (+wrap.dataset.dwell || 4500);
  let i = 0, t0 = performance.now(), visible = false, syncing = false;
  const stickerFor = (k) => { const s = items[k].dataset.solve; return s === 'ext' ? document.querySelector('.st[data-upgrade="true"]') : document.querySelector('.st[data-slot="' + s + '"]'); };
  const line = wrap.querySelector('.line i');
  const paint = (p) => {
    if (line) line.style.setProperty('--p', ((i + p) / items.length).toFixed(4));
    items.forEach((el, j) => { el.classList.toggle('is-active', j === i); el.style.setProperty('--p', j < i ? 1 : j === i ? p : 0); });
    segs.forEach((el, j) => { el.classList.toggle('is-active', j === i); el.style.setProperty('--p', j < i ? 1 : j === i ? p : 0); });
  };
  const show = (k, opts) => {
    i = ((k % items.length) + items.length) % items.length; t0 = performance.now(); paint(reduced ? 1 : 0);
    if (!(opts && opts.fromSticker)) { const st = stickerFor(i); if (st && !st.classList.contains('is-active')) { st.__fromSolves = true; st.click(); st.__fromSolves = false; } }
  };
  window.__solvesSync = (s) => { if (s === null) return; const k = items.findIndex(el => el.dataset.solve === s); if (k >= 0 && k !== i) show(k, { fromSticker: true }); else if (k === i) { t0 = performance.now(); } };
  const tick = (now) => {
    if (visible && dwell !== Infinity) { const p = Math.min(1, (now - t0) / dwell); paint(p); if (p >= 1) show(i + 1); }
    requestAnimationFrame(tick);
  };
  let started = false;
  if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) { t0 = performance.now(); if (!started) { started = true; show(0); } } }, { threshold: .35 }).observe(wrap); else { visible = true; }
  items.forEach((el, k) => el.addEventListener('click', () => { if (matchMedia('(max-width: 960px)').matches) show(i + 1); else show(k); }));
  segs.forEach((el, k) => el.addEventListener('click', e => { e.stopPropagation(); show(k); }));
  /* distilled layout on phones: tapping the visible sticker advances to the next category */
  if (wrap.hasAttribute('data-solves-verbs')) document.querySelectorAll('.st:not(.upgrade):not(.core)').forEach(st => st.addEventListener('click', () => { if (st.__fromSolves) return; if (matchMedia('(max-width: 960px)').matches) show(i + 1); }));
  show(0); started = true; /* arm the first category and its sticker at init; the timer still waits for the section to be in view */
  requestAnimationFrame(tick);
})();

/* Sticky bar readout → back to the options: scroll the first option group into view and focus the chosen input */
document.querySelectorAll('[data-core-jump-options]').forEach(b => b.addEventListener('click', () => {
  const main = document.querySelector('[data-core-main]'); const fs = main && main.querySelector('.product-form__input'); if (!fs) return;
  const nav = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--rr-nav-h')) || 84;
  /* back to the top of the product (photo, name and the whole buy box), not just far enough to show the options */
  const y = Math.max(0, main.getBoundingClientRect().top + scrollY - nav - 8);
  window.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  const checked = fs.querySelector('input:checked') || fs.querySelector('input'); if (checked) setTimeout(() => checked.focus({ preventScroll: true }), 450);
}));
